import { render, staticRenderFns } from "./JustificationReasonEntryDialog.vue?vue&type=template&id=c1065126&scoped=true"
import script from "./JustificationReasonEntryDialog.vue?vue&type=script&lang=js"
export * from "./JustificationReasonEntryDialog.vue?vue&type=script&lang=js"
import style0 from "./JustificationReasonEntryDialog.vue?vue&type=style&index=0&id=c1065126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1065126",
  null
  
)

export default component.exports